import { rgba } from 'polished';
import styled from 'styled-components';

import BasePrivacyOnIcon from '#/assets/PrivacyOnIcon';

import { c1D1D37, c14142E, cFFFFFF } from '#/colors';

import ButtonLink from '#/components/shared/ButtonLink';
import * as Alert from '#/components/common/Alert';

import { useTranslation } from '#/features/localization/utils';
import { useAccountProfileView } from '#/features/account/account-profile-context';
import { useUsernameEditModalActions } from '#/features/account/username-edit-modal-context';
import Tooltip, { HelpCursor } from '#/components/shared/Tooltip';

export default function UsernameSection() {
  const accountProfileView = useAccountProfileView();
  const usernameModal = useUsernameEditModalActions();
  const { t } = useTranslation();

  return (
    <Section aria-labelledby="account-dialog-username-section-title">
      <SectionHeading id="account-dialog-username-section-title">
        <span css="grid-area: title">{t('Username')}</span>
        <span css="grid-area: actions">
          {accountProfileView.status === 'connected' && (
            <EditButton onClick={usernameModal.open}>{t('Edit')}</EditButton>
          )}
        </span>
      </SectionHeading>
      <SectionContent />
    </Section>
  );
}

function SectionContent() {
  const accountProfileView = useAccountProfileView();
  const { t } = useTranslation();

  if (accountProfileView.error.length > 0) {
    return <Alert.Error>{accountProfileView.error}</Alert.Error>;
  }

  return (
    <Block>
      {accountProfileView.username.length === 0 ? (
        <span css="opacity: 0.5">-</span>
      ) : (
        <Grid>
          <span>{accountProfileView.username}</span>
          {accountProfileView.isUsernamePrivate && (
            <Tooltip
              label={t(
                'Your username is now hidden. It is not visible to other users.',
              )}
            >
              <HelpCursor>
                <PrivacyOnIcon aria-label="Username is set as hidden" />
              </HelpCursor>
            </Tooltip>
          )}
        </Grid>
      )}
    </Block>
  );
}

const Section = styled.section`
  display: grid;
  gap: 12px;
`;

const SectionHeading = styled.h2`
  color: ${rgba(cFFFFFF, 0.7)};
  font-size: 12px;
  font-weight: 500;
  margin: 0;
  display: grid;
  grid-template-areas: 'title actions';
  grid-template-columns: 1fr auto;
`;

const Grid = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 1fr auto;
  align-items: center;
`;

const Block = styled.div`
  border: 1px solid ${c1D1D37};
  border-radius: 7px;
  background-color: ${c14142E};
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  font-weight: 500;
  padding: 0 16px;
`;

const EditButton = styled(ButtonLink)`
  font-size: 12px;
`;

const PrivacyOnIcon = styled(BasePrivacyOnIcon)`
  color: ${rgba(cFFFFFF, 0.7)};
`;
